import { useEffect, useState } from "react";
import { Consent, readConsent, subscribeConsent } from "./consentStore";

// Current cookie choice; re-renders when the visitor changes it.
export const useConsent = (): {
  consent: Consent | null;
  hasDecided: boolean;
  externalMediaAllowed: boolean;
} => {
  const [consent, setConsent] = useState<Consent | null>(() => readConsent());

  useEffect(() => subscribeConsent(() => setConsent(readConsent())), []);

  return {
    consent,
    hasDecided: consent !== null,
    externalMediaAllowed: consent?.externalMedia === true,
  };
};
